import Alpine from 'alpinejs';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

Alpine.data('browsermockup', () => ({
    init() {
        const browserMockup = this.$root;

        let browserMockupInner = browserMockup.querySelector('.browser-mockup__inner');
        let browserMockupContent = browserMockup.querySelector('.browser-mockup__content');
        let browserMockupContentInner = browserMockup.querySelector('.browser-mockup__content__inner');
        let browserMockupContentHeight = browserMockupContent.getBoundingClientRect().height;
        let browserMockupContentInnerHeight = browserMockupContentInner.getBoundingClientRect().height;

        if (browserMockupContentHeight >= browserMockupContentInnerHeight) {
            browserMockup.classList.add('browser-mockup--is-not-scrollable');
            return;
        }

        gsap.registerPlugin(ScrollTrigger);

        let endPosition =
            browserMockupContent.getBoundingClientRect().height -
            browserMockupContentInner.getBoundingClientRect().height;

        gsap.fromTo(
            browserMockupContentInner,
            {
                y: 0,
            },
            {
                y: endPosition,
                ease: 'none',
                scrollTrigger: {
                    trigger: browserMockup,
                    start: 'top top',
                    end: () => `+=${browserMockupContentInnerHeight}`,
                    pin: browserMockupInner,
                    invalidateOnRefresh: true,
                    scrub: 0,
                    snap: false,
                    markers: false, //dev
                },
            }
        );
    },
}));
